import React from 'react';

const CONFIG = {
	awaitingPickup: {
		label: 'Awaiting Pickup',
		color: '#f5a623',
		bgLight: '#fff8f0',
		// Clock icon
		icon: 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z',
	},
	enRoute: {
		label: 'En Route',
		color: '#2ec4a5',
		bgLight: '#e8f7f4',
		// Truck icon
		icon: 'M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0zM13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0',
	},
	onVehicleForDelivery: {
		label: 'On Vehicle for Delivery',
		color: '#3b8ef3',
		bgLight: '#eef4ff',
		// Home/destination icon
		icon: 'M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2zM9 22V12h6v10',
	},
	delivered: {
		label: 'Delivered',
		color: '#27ae60',
		bgLight: '#eafaf1',
		// Check-circle icon
		icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
	},
	exception: {
		label: 'Exceptions',
		color: '#e85d75',
		bgLight: '#fff0f3',
		// Alert triangle icon
		icon: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z',
	},
	total: {
		label: 'Total',
		color: '#6b7a8d',
		bgLight: '#f0f3f6',
		// Package icon
		icon: 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4',
	},
};

export default function TrackingStatusCard({ statusKey, value, active, onClick }) {
	const cfg = CONFIG[statusKey] || CONFIG.total;
	const activeStyle = active
		? { background: cfg.color, borderColor: cfg.color }
		: {};

	return (
		<div
			className={`status-card tracking-status-card${active ? ' status-card--active' : ''}`}
			style={activeStyle}
			onClick={onClick}
		>
			<div
				className="status-card__icon"
				style={active ? { background: 'rgba(255,255,255,0.2)' } : { background: cfg.bgLight }}
			>
				<svg
					width="15" height="15"
					viewBox="0 0 24 24"
					fill="none"
					stroke={active ? '#fff' : cfg.color}
					strokeWidth="1.8"
					strokeLinecap="round"
					strokeLinejoin="round"
				>
					<path d={cfg.icon} />
				</svg>
			</div>
			<div>
				<div
					className="status-card__label"
					style={active ? { color: 'rgba(255,255,255,0.8)' } : {}}
				>
					{cfg.label}
				</div>
				<div
					className="status-card__value"
					style={active ? { color: '#fff' } : {}}
				>
					{(value || 0).toLocaleString()}
				</div>
			</div>
		</div>
	);
}